// extracted by css-extract-rspack-plugin
export default {"overlayContainer":"overlayContainer-UDiLQo","container":"container-LSMKdc","footerContainer":"footerContainer-o6QKNn","closeCta":"closeCta-pH24bt","deleteCta":"deleteCta-Y0ZPuC"};